import ZoneLmsProfile from "@/views/custom/ZoneLmsProfile.vue";
import ChargingRateDetail from "@/views/custom/ChargingRateDetail.vue";
import SelectCpByChargingRate from "@/views/crud/modules/SelectCpByChargingRate";


export default {
    key: "charging_rate",

    action: ["create","edit","editview","delete","view"],
    default:{
        type:"Time"
    },
    fields: [
        {key: "id"},
        {key :"name"},
        {key: "type", field:"type.name", value:"type.id", type:"select", disabled:["create","edit"]},
        {key: "gracing_period"},
        // {key: "max_charging_unit"},
        // {key: "max_penalty_unit"},
        { key: "loc_id", type: "select" , hidden: ["list"], disabled_by_column:true },
        // {key: "max_charging_duration_mins"},
        {key: "max_daily_charging_session"},
        {key: "redeem_period"},
        // {key: "max_redeem_count"},
        // {key: "penalty_rate"},
        // {key: "time_rate"},
        
        // {key: "unit", field:"unit.name", value:"unit.id", type:"select"},
        // {key: "charging_rate_detail", type: "componentColumn", component: ChargingRateDetail, hidden: ["list","create"] },
        {type: "action-btn", privilege: ["EDIT_CHARGING_RATE"], width: 150}
    ],
    options: {
        loc_id: {
          key: "cp_locs",
          label: "address",
          value: "loc_id"
        },
        type: {
            key: "charging_rate_type",
            label: "name",
            value: "id"
        },
        unit: {
            key: "charging_rate_unit",
            label: "name",
            value: "id",
        }
    },
    structure:[
        ["name","type"],
        ["loc_id"],
        ["gracing_period", "max_daily_charging_session"],
        ["max_charging_unit"],
        ["redeem_period"],
        ["charging_rate_detail"]
    ],
    view: [
        ["name",{key: "type", field:"type.name", value:"type.id", type:"select"}],
        [{ key: "loc_id", options:{key:"cp_locs"}, type: "select" }],
        ["gracing_period", "max_daily_charging_session"],
        ["max_charging_unit", "redeem_period"],
        // [{key:"charging_rate_detail",type: "component", component: ChargingRateDetail}],
    ],
    disabled_by_column:{
      edit:[
        {key:"loc_id", type:"isNotEmpty"}
      ]
    },
    extra_components: {
        view: [
            ChargingRateDetail,
            SelectCpByChargingRate
        ],
        editview: [
            ChargingRateDetail,
            SelectCpByChargingRate
        ]
    }
}